"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointDetailNewRequest = void 0;
var MyPointDetailNewRequest = /** @class */ (function () {
    function MyPointDetailNewRequest() {
    }
    return MyPointDetailNewRequest;
}());
exports.MyPointDetailNewRequest = MyPointDetailNewRequest;
;
//# sourceMappingURL=myPointDetail.request.js.map